module.exports = __webpack_public_path__ + "img/mysql.754e01e4.png";